/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { toLower } from 'lodash'
import { useIntl } from 'react-intl'
import FormField, {
  FormTextFieldProps
} from '../../../../client/js/components/form/fields/FormField'

function SlugField (props: FormTextFieldProps) {
  const { name = 'slug', ...others } = props
  const intl = useIntl()
  return (
    <FormField
      label={intl.formatMessage({
        id: 'slug',
        defaultMessage: 'Slug'
      })}
      name={name}
      parser={toLower}
      {...others}
    />
  )
}

export default SlugField
